import React from 'react'
import './Services.css'
import serviceInfography from '../../assets/img/service-infography.svg'
import serviceDevelopment from '../../assets/img/service-development.svg'
import serviceDesign from '../../assets/img/service-design.svg'
import { useTranslation } from 'react-i18next'

const Services = () => {
  const { t } = useTranslation();
  
  return (
    <section id='services' className="content_section">
      <div className="content_section_inner">
        <h2>{t('services.title')}</h2>
        <div className='container'>

          <div className='col col-1'>
            <div className='service-item'>
              <img src={serviceInfography} alt="" />
              <h4>{t('services.infography.title')}</h4>
              <p>{t('services.infography.description')}</p>
            </div>
          </div>

          <div className='col col-1'>
          <div className='service-item'>
              <img src={serviceDevelopment} alt="" />
              <h4>{t('services.development.title')}</h4>
              <p>{t('services.development.description')}</p>
            </div>
          </div>

          <div className='col col-1'>
          <div className='service-item'>
              <img src={serviceDesign} alt="" />
              <h4>{t('services.design.title')}</h4>
              <p>{t('services.design.description')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
} 

export default Services